import { border, color, fontSize, fontWeight, margin } from "@mui/system";


export const classes = {
    tableHeader: {
        fontSize: "16px",
        fontWeight: "bold"
    },
    filter: {
        mt: 3,
        ml: 1,
        fontSize: "16px",
        fontWeight: "bold"
    },
    tablecell: {
        border: "none"
    },
    FormControl: {
        m: 1,
        minWidth: 208,
        width: { xs: "100%", sm: "100%", lg: 0, md: 0 }
    },
    BeneficiaryData:{
        color: "#828282",
        fontWeight: "700",
        marginBottom: "8px"
    }
}